// Test IDs for Orbital Exchange app
export const NAV = {
  landingCtaLogin: "landing-cta-login",
  landingCtaRegister: "landing-cta-register",
  landingCtaDashboard: "landing-cta-dashboard",
  sidebarDashboard: "sidebar-dashboard",
  sidebarMarkets: "sidebar-markets",
  sidebarTrade: "sidebar-trade",
  sidebarWallet: "sidebar-wallet",
  sidebarTransactions: "sidebar-transactions",
  sidebarBanks: "sidebar-banks",
  sidebarAdmin: "sidebar-admin",
  topbarFiatSwitcher: "topbar-fiat-switcher",
  topbarLogout: "topbar-logout",
};

export const DASHBOARD = {
  totalBalance: "dashboard-total-balance",
  depositButton: "dashboard-deposit-button",
  withdrawButton: "dashboard-withdraw-button",
  tradeButton: "dashboard-trade-button",
};

export const TRADE = {
  assetSelect: "trade-asset-select",
  fiatSelect: "trade-fiat-select",
  sideBuy: "trade-side-buy",
  sideSell: "trade-side-sell",
  amountInput: "trade-amount-input",
  submit: "trade-submit-button",
};

export const WALLET = {
  depositFiatTab: "wallet-deposit-fiat-tab",
  withdrawFiatTab: "wallet-withdraw-fiat-tab",
  depositCryptoTab: "wallet-deposit-crypto-tab",
  withdrawCryptoTab: "wallet-withdraw-crypto-tab",
  convertTab: "wallet-convert-tab",
  depositFiatSubmit: "wallet-deposit-fiat-submit",
  withdrawFiatSubmit: "wallet-withdraw-fiat-submit",
  depositCryptoSubmit: "wallet-deposit-crypto-submit",
  withdrawCryptoSubmit: "wallet-withdraw-crypto-submit",
  convertSubmit: "wallet-convert-submit",
};

export const BANKS = {
  addButton: "banks-add-button",
  submitButton: "banks-submit-button",
  bankNameInput: "banks-bank-name-input",
  holderInput: "banks-holder-input",
  ibanInput: "banks-iban-input",
  currencySelect: "banks-currency-select",
  countryInput: "banks-country-input",
};

export const ADMIN = {
  statsAum: "admin-stats-aum",
  statsUsers: "admin-stats-users",
  usersTable: "admin-users-table",
  depositAddressesTable: "admin-deposit-addresses-table",
};
